/* eslint-disable no-shadow */
/* eslint-disable simple-import-sort/sort */
import { Grid, Typography, withStyles } from '@material-ui/core'
import styles from '../../../../resources/theme/global'
import React, { useEffect } from 'react'
import colors from '../../../../assets/colors'
import { useDispatch, useSelector } from 'react-redux'
import Filter from './Filter.jsx'
import List from './List.jsx'
import { useQueryParams } from '../../../../util/utils.js'
import { usePermissions } from '../../../../hooks/usePermission'
import { Link, Route } from 'react-router-dom'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min.js'
import { fetchAppointments } from '../AppointmentsActions.js'
import { NewAppointment } from './New.jsx'

const Appointments = props => {
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate, canRead } = usePermissions()

  const { classes } = props

  const dispatch = useDispatch()
  const location = useLocation()
  const filters = useQueryParams(location.search)

  useEffect(() => {
    dispatch(
      fetchAppointments(filters, filters?.rows || 10, filters?.page || 1)
    )
  }, [location])

  return (
    <>
      <Grid
        container
        className={classes.pageHead}
        spacing={2}
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography
            variant="h4"
            style={{ fontSize: '20px' }}
            color={colors.primary}
          >
            Agendamentos Avulsos
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Filter classes={classes} />
        </Grid>
      </Grid>

      {canCreate('modulo-parceiros-agendamentos', permissionUser) && (
        <Route
          path="/partners-module/appointments/new"
          component={NewAppointment}
        />
      )}

      {canRead('modulo-parceiros-agendamentos', permissionUser) && <List />}
    </>
  )
}

export default withStyles(styles)(Appointments)
